import { ICustomerCare } from 'affiny-core/modules/api/models/customerCare/customerCare.type';
import { getFAQLink } from 'affiny-core/modules/api/repositories/customerCare';
import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import {
  customerCareActions,
  ECustomerCareActionType,
} from 'affiny-core/modules/customerCare/actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const openLink = (url?: string, target?: string) => window.open(url, target);

export function* getFAQLinkSagaWeb() {
  // We need this to make the redirection work on safari
  // Safari blocks calls to window.open in asynchronous calls
  const windowReference = openLink();
  const response: ICustomerCare = yield call(getFAQLink);

  if (windowReference)
    // This enables to change the location of the newly opened tab once the link has been fetched
    windowReference.location.assign(response.link);

  yield put(customerCareActions.getFAQSuccess());
}

export function* customerCareSaga() {
  yield all([
    takeLatest(
      ECustomerCareActionType.GET_FAQ,
      handleAsyncStatus(getFAQLinkSagaWeb, EAsyncEventTypes.GET_FAQ)
    ),
  ]);
}
